"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getArrayIndex = _interopRequireDefault(require("./utils/get-array-index"));

var _getKey3 = _interopRequireDefault(require("./utils/get-key"));

var _shallowCopy = _interopRequireDefault(require("./utils/shallow-copy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Parse an object key from dot notation
 * @example
 * parseKey('person.name', 'John Doe');
 * // output { person: { name: 'John Doe' } }
 * parseKey('person.alias[]', 'John Doe');
 * // output { person: { alias: ['John Doe'] } }
 * @param {string} path - Dot notation path
 * @param {unknown} value
 * @returns {object}
 */
var parseKey = function parseKey(path, value) {
  var _getKey = (0, _getKey3.default)(path),
      _getKey2 = _slicedToArray(_getKey, 2),
      key = _getKey2[0],
      remainingPath = _getKey2[1];

  var hasArrayNotation = (0, _getArrayIndex.default)(key);
  var compiledValue = remainingPath ? parseKey(remainingPath, value) : (0, _shallowCopy.default)(value);
  return hasArrayNotation ? [compiledValue] : _defineProperty({}, key, compiledValue);
};

var _default = parseKey;
exports.default = _default;